import Vue from 'vue';
import 'trix';
import 'trix/dist/trix.css';

/**
 *
 * @param {*} component
 */
function EmitAttachmentAdd (component) {
  return {
    methods: {
      emitAttachmentAdd: function emitAttachmentAdd (file) {
        this.$emit('trix-attachment-add', file);
      }
    }
  }
}

/**
 *
 * @param {*} component
 */
function EmitAttachmentRemove (component) {
  return {
    methods: {
      emitAttachmentRemove: function emitAttachmentRemove (file) {
        this.$emit('trix-attachment-remove', file);
      }
    }
  }
}

//

var script = {
  name: 'VueTrix',
  mixins: [
    EmitAttachmentAdd('VueTrix'),
    EmitAttachmentRemove('VueTrix')
  ],
  model: {
    prop: 'initContent',
    event: 'update'
  },
  props: {
    inputId: {
      type: String,
      required: false,
      default: function default$1 () {
        return ''
      }
    },
    placeholder: {
      type: String,
      required: false,
      default: function default$2 () {
        return ''
      }
    },
    initContent: {
      type: String,
      required: false,
      default: function default$3 () {
        return ''
      }
    },
    localStorage: {
      type: Boolean,
      required: false,
      default: function default$4 () {
        return false
      }
    }
  },
  mounted: function mounted () {
    if (this.localStorage) {
      var savedValue = localStorage.getItem(this.storageId('VueTrix'));
      if (savedValue && !this.$props.initContent) {
        this.$refs.trix.editor.loadJSON(JSON.parse(savedValue));
      }
    }
  },
  data: function data () {
    return {
      editorContent: this.initContent
    }
  },
  methods: {
    update: function update (event) {
      this.$emit('update', event.srcElement.innerHTML);
    },
    saveEditorState: function saveEditorState (val) {
      if (this.localStorage) {
        localStorage.setItem(this.storageId('VueTrix'), JSON.stringify(this.$refs.trix.editor));
      }
    },
    storageId: function storageId (component) {
      if (this.$props.inputId) {
        return (component + "." + (this.$props.inputId) + ".content")
      } else {
        return (component + ".content")
      }
    }
  },
  computed: {
    randomId: function randomId () {
      var text = '';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      for (var i = 0; i < 10; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text
    }
  },
  watch: {
    initContent: {
      handler: 'saveEditorState'
    }
  }
};

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "trix-container" },
    [
      _c("trix-editor", {
        ref: "trix",
        staticClass: "trix-content",
        attrs: {
          input: _vm.inputId || _vm.randomId,
          placeholder: _vm.placeholder
        },
        on: {
          "trix-change": _vm.update,
          "trix-attachment-add": _vm.emitAttachmentAdd,
          "trix-attachment-remove": _vm.emitAttachmentRemove
        }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: {
          type: "hidden",
          name: "content",
          id: _vm.inputId || _vm.randomId
        },
        domProps: { value: _vm.initContent },
        on: { input: _vm.update }
      })
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-c8962d9a_0", { source: "\n.trix-container[data-v-c8962d9a] {\n  max-width: 100%;\n  height: auto;\n}\n\n/*# sourceMappingURL=VueTrix.vue.map */", map: {"version":3,"sources":["/home/chicky/side_proj/vue_workspace/vue-trix/src/components/VueTrix.vue","VueTrix.vue"],"names":[],"mappings":";AAoHA;EACA,gBAAA;EACA,aAAA;CACA;;ACnHA,uCAAuC","file":"VueTrix.vue","sourcesContent":[null,".trix-container {\n  max-width: 100%;\n  height: auto; }\n\n/*# sourceMappingURL=VueTrix.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = "data-v-c8962d9a";
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* component normalizer */
  function __vue_normalize__(
    template, style, script$$1,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    var component = (typeof script$$1 === 'function' ? script$$1.options : script$$1) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "/home/chicky/side_proj/vue_workspace/vue-trix/src/components/VueTrix.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) { component.functional = true; }
    }

    component._scopeId = scope;

    {
      var hook;
      if (style) {
        hook = function(context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          var originalRender = component.render;
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context)
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = component.beforeCreate;
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    var head = document.head || document.getElementsByTagName('head')[0];
    var styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {});
    var isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) { return } // SSR styles are present.

      var group = isOldIE ? css.media || 'default' : id;
      var style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

      if (!style.ids.includes(id)) {
        var code = css.source;
        var index = style.ids.length;

        style.ids.push(id);

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']');
        }

        if (!style.element) {
          var el = style.element = document.createElement('style');
          el.type = 'text/css';

          if (css.media) { el.setAttribute('media', css.media); }
          if (isOldIE) {
            el.setAttribute('data-group', group);
            el.setAttribute('data-next-index', '0');
          }

          head.appendChild(el);
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'));
          style.element.setAttribute('data-next-index', index + 1);
        }

        if (style.element.styleSheet) {
          style.parts.push(code);
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n');
        } else {
          var textNode = document.createTextNode(code);
          var nodes = style.element.childNodes;
          if (nodes[index]) { style.element.removeChild(nodes[index]); }
          if (nodes.length) { style.element.insertBefore(textNode, nodes[index]); }
          else { style.element.appendChild(textNode); }
        }
      }
    }
  }
  /* style inject SSR */
  

  
  var VueTrix = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    __vue_create_injector__,
    undefined
  );

/*
* Vue-Trix index.js
* Author: tranduchanh.ms@gmail.com
* Github: https://github.com/hanhdt/vue-trix
*/
Vue.config.ignoredElements = ['trix-editor'];

Vue.component(VueTrix.name, VueTrix);

export default VueTrix;
//# sourceMappingURL=vue-trix.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vue-trix/dist/vue-trix.esm.js
// module id = 40
// module chunks = 0